var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeatherDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50526",
    "data-name": "Path 50526",
    d: "M14,22.5v2.111a1.056,1.056,0,0,1-1.056,1.056H5.556A1.056,1.056,0,0,1,4.5,24.611V22.5",
    transform: "translate(-4.5 -16.166)",
    fill: "none",
    stroke: "#30B524",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50527",
    "data-name": "Path 50527",
    d: "M10.5,15l2.639,2.639L15.778,15",
    transform: "translate(-8.389 -11.305)",
    fill: "none",
    stroke: "#30B524",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50528",
    "data-name": "Path 50528",
    d: "M18,10.834V4.5",
    transform: "translate(-13.25 -4.5)",
    fill: "none",
    stroke: "#30B524",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherDownload);
export default __webpack_public_path__ + "static/media/Icon-feather-download.ca3616ff19f513e515011674f1d5fdce.svg";
export { ForwardRef as ReactComponent };